import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { TextField, IconButton, InputAdornment } from '@mui/material';
import Iconify from '../../iconify';

CustomNumberPanel.propTypes = {
  activeFilter: PropTypes.string,
  filters: PropTypes.object,
  setFilters: PropTypes.func
};

export default function CustomNumberPanel({ activeFilter, filters, setFilters }) {
  const [value, setValue] = useState(filters[activeFilter]?.value[0] || '');

  useEffect(() => {
    setValue(filters[activeFilter]?.value[0] || '');
  }, [activeFilter, filters]);

  const handleChange = (e) => {
    const newValue = parseInt(e.target.value, 10);

    if (!Number.isNaN(newValue)) {
      setValue(newValue);
      const newFilters = { ...filters, [activeFilter]: { value: [newValue], operator: 'contains' } };
      setFilters(newFilters);
    } else {
      setValue('');
      const newFilters = { ...filters };
      delete newFilters[activeFilter];
      setFilters(newFilters);
    }
  };

  const handleClear = () => {
    setValue('');
    const newFilters = { ...filters };
    delete newFilters[activeFilter];
    setFilters(newFilters);
  };

  return (
    <TextField
      type="number"
      value={value}
      onChange={handleChange}
      autoComplete="off"
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton onClick={handleClear}>
              <Iconify icon={'ri:close-fill'} width={20} height={20} sx={{ cursor: 'pointer' }} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}